import type { ThemeDefinition } from 'vuetify';

const light: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#ffffff',
    //TODO theme colors
    primary: '#026f47',
    'primary-lighter': '#4CAF50',
    secondary: '#007561',
    success: '#4caf50',
    info: '#3498ff',
    'info-lighten-1': '#f0f9ff',
    warning: '#ffb300',
    error: '#df2026',
    blue: '#3498ff'
  }
};

const dark: ThemeDefinition = {
  dark: true,
  colors: {}
};

export default { light, dark };
